import React, { useEffect, useState } from "react";
import { Form, redirect, ActionFunctionArgs, Link } from "react-router-dom";
import toast from "react-hot-toast";
import { Input, PasswordInput } from "../../components/inputs/Input";
import { LoginButton } from "../../components/Button";
import { ClerkLoginError, login } from "./api";
import { userStore } from "../../store/user";

const { getState } = userStore;

export const loginAction = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const username = formData.get("username");
  const password = formData.get("password");

  if (!username || !password) {
    return toast.error("Please enter a username and password.");
  }
  try {
    await login({
      username: username as string,
      password: password as string,
    });
    return redirect("/dashboard");
  } catch (e: any) {
    if (e instanceof ClerkLoginError) {
      return toast.error(
        "This is a clerk account. Clerk accounts can only sign in on the POS tablets, not the dashboard. Contact an administrator if you need dashboard access."
      );
    }
    // ronin-api's login_dashboard rejects deactivated users with
    // extensions.name === 'accountInactive'.
    const inactive = e?.graphQLErrors?.some(
      (err: any) => err?.extensions?.name === "accountInactive"
    );
    const errorMessage = inactive
      ? "This account has been deactivated. Contact an administrator."
      : "Invalid username or password.";
    return toast.error(errorMessage);
  }
};

export const loginLoader = async () => {
  const user = getState().user;
  if (user) {
    return redirect("/dashboard");
  }
  return {};
};

const LoginPage = () => {
  const [deployDate, setDeployDate] = useState<string | null>(null);
  useEffect(() => {
    async function fetchDeployDate() {
      const response = await fetch(
        "https://api.vercel.com/v6/deployments?teamId=team_UXkC3yKuDivTqKgMln3DsqmU",
        {
          headers: {
            Authorization: `Bearer ${import.meta.env.VITE_DEPLOY_DATE_API_KEY}`,
          },
        }
      );
      const data = await response.json();
      if (data.deployments && data.deployments.length > 0) {
        setDeployDate(new Date(data.deployments[0].createdAt).toLocaleString());
      }
    }
    fetchDeployDate();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <Form method="post" action="/login">
        <div className="p-5 bg-white rounded-lg shadow-lg w-full grid gap-4">
          <img
            className="h-40 w-auto justify-self-center"
            src="/static/logo-standard-compressed.svg"
            alt="Ronin"
          />
          <Input label="Username" name="username" type="text" />
          <PasswordInput label="Password" name="password" />
          <LoginButton type="submit">Login</LoginButton>
          <Link
            to="/login/forgot-password"
            className="block text-sm font-medium text-blue-500 hover:text-blue-700 text-center"
          >
            Forgot Password?
          </Link>
          <Link
              to="https://storage.googleapis.com/posapp-apk-builds/builds/release-20261020194000-510.apk"
              className="block text-sm font-medium text-blue-500 hover:text-blue-700 text-center"
          >
            Download APK - 510
          </Link>
          {/*
            QA build. Keep the production link above it on the build that is
            actually released. A build only moves up to that link after its
            server side is deployed.

            The file name comes from posapp/cloudbuild.yaml:
            release-<versionName>-<versionCode>.apk, both read out of
            posapp/android/app/build.gradle. The link 404s until that build
            runs. posapp builds are numbered in the 500s from build 500 on;
            posapp-s700 builds move to the 600s.
          */}
          <Link
              to="https://storage.googleapis.com/posapp-apk-builds/builds/release-20261102112700-513.apk"
              className="block text-sm font-medium text-blue-500 hover:text-blue-700 text-center"
          >
            Download APK - 513 - QA
          </Link>
          <Link
              to="https://ronin-apks.s3.amazonaws.com/TimeClock.apk"
              className="block text-sm font-medium text-blue-500 hover:text-blue-700 text-center"
          >
            Timeclock App
          </Link>
          <Link
              to="https://webfrontend.ashyfield-84b5f8cf.centralus.azurecontainerapps.io"
              className="block text-sm font-medium text-blue-500 hover:text-blue-700 text-center"
          >
            Commissary Manager
          </Link>
          <label className="block text-sm font-medium text-gray-700">
            Last Deployed: {deployDate}
          </label>
        </div>
      </Form>
    </div>
  );
};

export default LoginPage;
